import { render, staticRenderFns } from "./ProductDetailSkeleton.vue?vue&type=template&id=57272c26&"
import script from "./ProductDetailSkeleton.vue?vue&type=script&lang=js&"
export * from "./ProductDetailSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports